export default "__VITE_ASSET__CAYhMjce__"